/*
 *
 * File JS categories
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./categories.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const categories = () => {
    let allCategoriesSlider = document.querySelectorAll(".categories");

    if (!allCategoriesSlider.length) return;

    allCategoriesSlider.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");
        let scrollbar = el.querySelector(".scrollbar");
        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: "auto",
            breakpoints: {
                0: {
                    spaceBetween: 8,
                },
                768: {
                    spaceBetween: 10,
                },
                scrollbar: {
                    el: scrollbar,
                    hide: false,
                },
            },
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default categories;

//--------------------------------------------------------------------//
